import { createContext, useContext } from 'react';

type TiptapPopupContextValue = {
    availableHeight?: number;
    setPreferredHeight?: (preferredHeight: number) => void;
};

export const TiptapPopupContext = createContext<TiptapPopupContextValue | null>(null);

export const useTiptapPopupContext = (): TiptapPopupContextValue | null => useContext(TiptapPopupContext);
